import { COLORS } from "../../utilities/Constants"

/**
 * Tokens de tableau V2 partagés — le langage commun des listes (/configuration,
 * /atelier/inventaire, modals). Conteneur arrondi + ombre douce, en-têtes
 * uppercase sur fond `bg`, zébrage, hover.
 *
 * Calqué EXACTEMENT sur /atelier/inventaire : `overflowX:auto / overflowY:hidden`
 * (et SURTOUT pas de `position:sticky` sur les th — un descendant sticky échappe
 * au clip `border-radius` et casse le coin arrondi du conteneur).
 *
 * `rowBg(i)` donne le fond zébré ; surcharger avec `rowHover` au survol.
 */
export const tableStyles = {
	container: {
		backgroundColor: COLORS.surface,
		borderRadius: 14,
		boxShadow:
			"0 1px 2px rgba(28, 25, 23, 0.04), 0 6px 20px rgba(28, 25, 23, 0.06)",
		overflowX: "auto",
		overflowY: "hidden",
	},
	table: {
		width: "100%",
		borderCollapse: "separate",
		borderSpacing: 0,
		fontSize: 13,
	},
	th: {
		padding: "12px 16px",
		textAlign: "left",
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		textTransform: "uppercase",
		letterSpacing: "0.06em",
		border: "none",
		borderBottom: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.bg,
		whiteSpace: "nowrap",
	},
	thRight: {
		padding: "12px 16px",
		textAlign: "right",
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		textTransform: "uppercase",
		letterSpacing: "0.06em",
		border: "none",
		borderBottom: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.bg,
		whiteSpace: "nowrap",
	},
	td: {
		padding: "12px 16px",
		border: "none",
		// ⚠ textAlign explicite obligatoire : App.css a un `td, th { text-align:
		// center }` GLOBAL — sans cette ligne les cellules retombent en centré.
		textAlign: "left",
		color: COLORS.text,
		verticalAlign: "middle",
		whiteSpace: "nowrap",
	},
	tdRight: {
		padding: "12px 16px",
		border: "none",
		color: COLORS.text,
		verticalAlign: "middle",
		whiteSpace: "nowrap",
		textAlign: "right",
		fontVariantNumeric: "tabular-nums",
	},
	empty: {
		padding: "28px 16px",
		textAlign: "center",
		color: COLORS.textMuted,
		fontSize: 13,
	},
	rowBg: (i) => (i % 2 === 1 ? COLORS.bg : COLORS.surface),
	rowHover: COLORS.border,
}
